import { render } from "./login.vue?vue&type=template&id=c22db9fe&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=c22db9fe&scoped=true&lang=scss"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22db9fe"]])

export default __exports__